<div>
  <div class="content" >
    <div class="row min-height" *ngIf="!masquageOngletsEtRecherche">
      <div class="col-lg-4">
        <h4><b>Déclarations</b></h4>
      </div>
      <div class="col-lg-4" *ngIf="isAnpp()">
        <app-search-adherent-actif-bar (newItemEvent)="addItem($event)"></app-search-adherent-actif-bar>
        <div>
          <strong>Adhérent : </strong><span *ngIf="declarationService.entrepriseSelectionnee && isAnpp()" class="col-lg-4">{{declarationService.entrepriseSelectionnee.raisonSociale}}</span>
        </div>
      </div>

    </div>
    <ng-container *ngIf="!masquageOngletsEtRecherche">
      <ul
        ngbNav
        class="nav-tabs mt-2"
        #nav="ngbNav"
        (navChange)="onTabChange($event)"
        [(activeId)]="declarationService.activeTabId"
        style="min-height: unset"
      >
        <li ngbNavItem="vergers">
          <a ngbNavLink>Inventaire vergers</a>
        </li>

        <ng-container *hasRole="'DECLARATION_RECOLTE_ECRITURE || ORGANISME'">
          <li ngbNavItem="recoltes">
            <a ngbNavLink>Récoltes</a>
          </li>
        </ng-container>

        <ng-container *hasRole="'DECLARATION_STOCK_ECRITURE || ORGANISME'">
          <li ngbNavItem="stocks">
            <a ngbNavLink>Stocks</a>
          </li>
        </ng-container>

        <ng-container *hasRole="'DECLARATION_ECOULEMENT_ECRITURE || ORGANISME'">
          <li ngbNavItem="ecoulements" >
            <a ngbNavLink>Ecoulements</a>
          </li>
        </ng-container>
      </ul>
      <div [ngbNavOutlet]="nav" class="mt-3"></div>
    </ng-container>

    <router-outlet></router-outlet>
  </div>
</div>
